module.exports = __webpack_public_path__ + "static/media/olu-eletu.4112cbc1.jpg";